import React from 'react';
import { Box, Link, styled } from '@mui/material';

const SignupFooter = () => {
  return (
    <Box mt={{ sm: 0, md: 1, lg: 2 }} textAlign="center">
      <WhiteLink
        href="/home/Company/Terms_of_Service"
        underline="always"
        sx={{ mx: 2 }}
      >
        Terms of Use
      </WhiteLink>
      <WhiteLink
        href="/home/Company/Privacy_Policy"
        underline="always"
        sx={{ mx: 2 }}
      >
        Privacy Policy
      </WhiteLink>
    </Box>
  );
};
const WhiteLink = styled(Link)(({ theme }) => ({
  color: theme.palette.mode === 'dark' ? 'white' : 'black',
  textDecoration: 'underline',
  '&:hover': {
    color: theme.palette.mode === 'dark' ? 'white' : 'black',
    textDecoration: 'underline',
  },
}));

export default SignupFooter;
